/**
 * @file index.tsx
 *
 * @fileoverview The page displays a form for the user to provide an
 * email address and on submit will make a call to the backend
 * to send a verification email.
 */

import React from 'react';
import { PasswordReset } from '~/jobiqo/components/User/PasswordReset';
import { GetServerSideProps, NextPage } from 'next';
import { withAuthenticateAnonymous } from '~/jobiqo/hocs/withAuthenticate/anonymous';

const PasswordResetPage: NextPage = () => <PasswordReset />;

export const getServerSideProps: GetServerSideProps = withAuthenticateAnonymous(
  {},
);

export default PasswordResetPage;
